module.exports = __webpack_public_path__ + "media/assets/relay-825434e27f244b1a7548400c514d4d66.png";